import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
    container: {
        display: 'flex',
        padding: 10,
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 200,
    },
    dense: {
        marginTop: 19,
    },
    menu: {
        width: 200,
    },
});

class Settings extends Component {
    static displayName = Settings.name;

    constructor(props) {
        super(props);
        this.clearStorage = this.clearStorage.bind(this);
        this.getStoredDataSize = this.getStoredDataSize.bind(this);

        this.state = {};
    }

    getStoredDataSize() {
        var _lsTotal = 0, _xLen, _x;
        for (_x in localStorage) {
            _xLen = (((localStorage[_x].length || 0) + (_x.length || 0)) * 2);
            _lsTotal += _xLen;
            console.log(_x.substr(0, 50) + " = " + (_xLen / 1024).toFixed(2) + " KB");
        };

        return (_lsTotal / 1024).toFixed(2) + " KB";
    }

    clearStorage() {
        localStorage.clear();
        this.props.history.push("/");
    }

    render() {
        return (
            <div>
                <Paper style={{ padding: 15 }}>
                    <Typography className={this.props.grow} variant="h6" color="inherit">Veľkosť dát na úložisku:</Typography>
                    <Typography className={this.props.grow} variant="h6" color="primary">{this.getStoredDataSize()}</Typography>
                    Vymazať všetky dáta reproHD lokálneho úložiska (Odhlási používateľa)
            <Button style={{ marginLeft: 15 }}
                        onClick={() => { this.clearStorage() }}
                        variant="contained"
                        color="secondary"
                    >Vymazať</Button>
                </Paper>
            </div>
        );
    }
}
export default (withStyles(styles)(Settings));



// WEBPACK FOOTER //
// ./src/components/technik/Settings.jsx